document.addEventListener('DOMContentLoaded', function () {
    const dialog = document.getElementById('c-popup');

    if (!dialog) {
        return;
    }

    const storageKey = 'c-popup-dismissed';

    if (sessionStorage.getItem(storageKey)) {
        return;
    }

    const delay = parseInt(dialog.dataset.delay ?? '0', 10) * 1000;

    setTimeout(function () {
        dialog.showModal();
    }, delay);

    dialog.querySelector('.c-popup__close').addEventListener('click', function () {
        dialog.close();
        sessionStorage.setItem(storageKey, '1');
    });

    dialog.addEventListener('cancel', function () {
        sessionStorage.setItem(storageKey, '1');
    });

    dialog.addEventListener('click', function (e) {
        const rect = dialog.getBoundingClientRect();
        const clickedBackdrop =
            e.clientX < rect.left ||
            e.clientX > rect.right ||
            e.clientY < rect.top ||
            e.clientY > rect.bottom;

        if (clickedBackdrop) {
            dialog.close();
            sessionStorage.setItem(storageKey, '1');
        }
    });
});
